import React from "react";
import _ from "lodash";
import { PRICE_TYPE, getPriceType, getPrice } from "./UPRSegmentationHelper";
import {
  inputClass,
  buttonModalConfirmClass,
  buttonModalConfirmDisable,
  buttonConfirmClass,
  buttonConfirmDisable,
} from "helpers/StyleClass";

const OptionTitle = {
  [PRICE_TYPE.NO_UPR]: "Set as no UPR",
  [PRICE_TYPE.FLOOR]: "Set floor prices",
  [PRICE_TYPE.TARGET_CPM]: "Set target CPMs",
  [PRICE_TYPE.LGO]: "Let Google optimize floor prices",
  [PRICE_TYPE.ALGO]: "Price Set by Algorithm",
};

const OptionDesc = {
  [PRICE_TYPE.NO_UPR]: "No UPR applied.",
  [PRICE_TYPE.FLOOR]:
    "The lowest winning bid must be at least as high as the floor price.",
  [PRICE_TYPE.TARGET_CPM]:
    "Floor prices are dynamic but average CPM over time targets the chosen CPM.",
  [PRICE_TYPE.LGO]:
    "Google automatically sets floor prices based on bidder behavior.",
  [PRICE_TYPE.ALGO]: "Chosen automatically through algorithmic selection.",
};

class PriceEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editType: PRICE_TYPE.FLOOR,
      editInput: "",
    };

    this.handleUpdatePrice = this.handleUpdatePrice.bind(this);
    this.handleApplyEdit = this.handleApplyEdit.bind(this);
    this.handleSyncEdit = this.handleSyncEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
  }

  componentDidMount() {
    const { price } = this.props;

    this.handleUpdatePrice(price);
  }

  componentDidUpdate(prevProps, prevState) {
    const { price } = this.props;

    if (price !== prevProps.price) {
      this.handleUpdatePrice(price);
    }

    if (
      this.state.editType !== prevState.editType ||
      this.state.editInput !== prevState.editInput
    ) {
      this.handleSyncEdit();
    }
  }

  handleUpdatePrice(price) {
    const { type, value } = getPriceType(price);
    this.setState({ editType: type, editInput: value || "" });
  }

  handleApplyEdit() {
    const { editType, editInput } = this.state;

    const price = getPrice({ type: editType, value: editInput });

    if (this.props.handleApply) {
      this.props.handleApply(price);
    }
  }

  handleSyncEdit() {
    const { editType, editInput } = this.state;

    const price = getPrice({ type: editType, value: editInput });

    if (this.props.handleSync) {
      this.props.handleSync(price);
    }
  }

  handleCancelEdit() {
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  }

  render() {
    const { editType, editInput } = this.state;

    const { hasController = true, supportAlgo = false } = this.props;

    const errInput =
      _.isNaN(_.toNumber(editInput)) ||
      _.toNumber(editInput) < 0 ||
      (editInput.toString().split(".")[1] || []).length > 2;

    const priceTypeList = supportAlgo
      ? _.values(PRICE_TYPE)
      : _.values(_.omit(PRICE_TYPE, [PRICE_TYPE.ALGO]));

    return (
      <>
        <div>Price Type:</div>
        <div className="flex flex-col gap-2">
          {priceTypeList.map((pt) => (
            <label
              key={pt}
              htmlFor={`radio_${pt}`}
              className="flex cursor-pointer items-center gap-2"
            >
              <input
                id={`radio_${pt}`}
                type="radio"
                value={pt}
                checked={editType === pt}
                onChange={() => this.setState({ editType: pt, editInput: "" })}
              />{" "}
              <div>
                <div className="font-semibold text-gray-800">
                  {OptionTitle[pt]}
                </div>
                <div className="text-xs leading-3 text-gray-600">
                  {OptionDesc[pt]}
                </div>
              </div>
            </label>
          ))}
        </div>

        {(editType === PRICE_TYPE.FLOOR ||
          editType === PRICE_TYPE.TARGET_CPM) && (
          <>
            <div className="mt-2">
              {editType === PRICE_TYPE.FLOOR ? "Floor Price:" : "Target CPM:"}
            </div>
            <input
              className={inputClass}
              value={editInput}
              onChange={(e) => this.setState({ editInput: e.target.value })}
              placeholder={
                editType === PRICE_TYPE.FLOOR
                  ? "Input floor pirce"
                  : "Input target CPM"
              }
            ></input>
          </>
        )}
        {errInput && (
          <div className="mt-1 bg-red-100 px-1 font-semibold text-red-700">
            Cannot be negative and only 2 decimal places are allowed
          </div>
        )}
        {hasController && (
          <div className="flex gap-2">
            <button
              className={errInput ? buttonConfirmDisable : buttonConfirmClass}
              onClick={this.handleApplyEdit}
              disabled={errInput}
            >
              Apply
            </button>
            <button
              className="px-4 text-blue-700"
              onClick={this.handleCancelEdit}
            >
              Cancel
            </button>
          </div>
        )}
      </>
    );
  }
}

export default PriceEditor;
